<p class="copyright">
  myVViD v.{{currentVersion}} &copy; {{currentYear}}
  <a rel="noopener" href="https://hivve.tech" target="_blank">HIVVE GROUP LTD.</a>
  &nbsp;
</p>
